import Const from 'const';
import SuffixMarker from 'services/simplex/suffix-marker';

const suffix = Const.LP_ITEM_DELIMITER + Const.LP_KEY_PLAYER_STACK_SUFFIX;

const KeyPlayerStackMarker = {
    suffix,
    ...SuffixMarker,
};

export default KeyPlayerStackMarker;
